import { CachedCRUDService } from '../../../types/cached-c-r-u-d.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { ServerResponse } from '../../../types/http.interfaces';
import { environment } from '../../../../../environments/environment';
import { ParametricsInterface } from '../../../types/parametrics.interface';
import {
  InterestPopulation,
  InterestPopulationChangeStatusInput,
  InterestPopulationCreateInput,
} from '@sisem/sisem-incidents-types';

@Injectable({
  providedIn: 'root',
})
export class IncidentsInterestPopulationsService extends CachedCRUDService<
  InterestPopulation,
  InterestPopulationCreateInput['data'],
  never
> {
  constructor(private http: HttpClient) {
    super();
    this.options.cacheExpiration = -1; // should almost never change, set don't expire
  }

  protected override async _fetchNewData(): Promise<InterestPopulation[]> {
    const response = await lastValueFrom(
      this.http.get<ServerResponse<InterestPopulation[]>>(
        `${environment.api}/incidents-ms/api/v1/interestPopulations`
      )
    );
    return response.data;
  }

  protected override async _getByIdData(id: number): Promise<InterestPopulation | undefined> {
    const res = await lastValueFrom(
      this.http.get<ServerResponse<InterestPopulation>>(
        `${environment.api}/incidents-ms/api/v1/interestPopulations/${id}`
      )
    );
    return res.data;
  }

  protected override async _postData(input: InterestPopulationCreateInput['data']) {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    const res = await lastValueFrom(
      this.http.post<ServerResponse<ParametricsInterface>>(
        `${environment.api}/incidents-ms/api/v1/interestPopulations`,
        input,
        { headers }
      )
    );
    const fixedRes = await this.getById(res.data.id, true);
    if (!fixedRes) {
      throw new Error('Could not fetch updated data, strange case, this should not happen');
    }
    this.removeId(res.data.id);
    return fixedRes;
  }

  protected override async _deleteData(_id: number): Promise<void> {
    await lastValueFrom(
      this.http.delete(`${environment.api}/incidents-ms/api/v1/interestPopulations/${_id}`)
    );
  }

  async changePopulationInterestStatus(
    id: number,
    data: InterestPopulationChangeStatusInput['data']
  ) {
    try {
      await lastValueFrom(
        this.http.post(
          `${environment.api}/incidents-ms/api/v1/interestPopulations/${id}/status`,
          data
        )
      );
    } catch (e) {
      console.error(e);
      throw e;
    }
  }
}
